import { Selector } from 'react-redux'
import { Country } from '@afterpaytouch/portal-api/types'
import { useAppSelector } from '..'
import { CheckoutAppState } from '../store'
import { isCountryNeedsBiometricVerification } from '../../model'

/* Selectors */

// @ts-expect-error: OPERATION BLEED STOPPER
export const countrySelector: Selector<CheckoutAppState, Country> = (state) => state.country?.initial

export const supportedCountriesSelector: Selector<CheckoutAppState, Country[]> = (state) => state.country.merchant

/* React Hooks */

export const useCountry = (): Country => useAppSelector(countrySelector)

export const useIsCountry = (country: Country): country is Country => {
  const currentCountry = useCountry()
  return currentCountry === country
}

export const useSupportedCountries = (): Country[] => useAppSelector(supportedCountriesSelector)

export const useIsCountryNeedsBiometricVerification = (): boolean => {
  const country = useCountry()
  return isCountryNeedsBiometricVerification(country)
}
